import {Component} from "react";
import "../Footer/Footer.css";
import logo from "../../media/logo-blanco.svg";
import fb_w from "../../media/fb-w.svg";
import tiktok_w from "../../media/tiktok-w.svg";
import insta_w from "../../media/insta-w.svg";

export default class Footer extends Component {
    render() {
        return (
            <footer>
                <div className="col">
                    <img src={logo} alt=""/>
                    <a href="">
                        Norte 15 4902, Magdalena de las Salinas, Ciudad de México
                    </a>
                    <a href="">
                        esteticadecalzadomag@gmail.com
                    </a>
                    <a href="">
                        55 57192238
                    </a>
                </div>
                <div className="col">
                    <div className="redes">
                        <a href="">
                            <img src={fb_w} alt=""/>
                        </a>
                        <a href="">
                            <img src={tiktok_w} alt=""/>
                        </a>
                        <a href="">
                            <img src={insta_w} alt=""/>
                        </a>
                    </div>
                    <a href="">
                        Términos y condiciones de garantía
                    </a>
                    <a href="">
                        Aviso de privacidad
                    </a>
                    <a href="">
                        Política de reembolso
                    </a>
                    <a href="">
                        Política de envíos
                    </a>
                </div>
            </footer>
        )
    }
}